import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      padding: [35, 0, 100],
    },
    title: {
      margin: "auto",
      textAlign: "center",
      maxWidth: 200,
      fontSize: theme.typography.pxToRem(20),
      fontWeight: 600,
      letterSpacing: 1.09,
      color: theme.palette.havelockBlue,
      lineHeight: theme.typography.pxToRem(34),
      [theme.breakpoints.up("mobile")]: {
        maxWidth: "none",
        fontSize: theme.typography.pxToRem(23),
        lineHeight: theme.typography.pxToRem(28),
        letterSpacing: 1.25,
      },
      [theme.breakpoints.up("tablet")]: {
        fontSize: theme.typography.pxToRem(28),
        lineHeight: theme.typography.pxToRem(34),
        letterSpacing: 1.5,
      },
    },
    description: {
      textAlign: "center",
      fontWeight: 600,
      fontSize: theme.typography.pxToRem(19),
      lineHeight: theme.typography.pxToRem(34),
      letterSpacing: ".86px",
      color: theme.palette.primary.main,
      padding: "10px 40px 0",
      [theme.breakpoints.up("tablet")]: {
        padding: "54px 134px 34px",
      },
    },
    grid: {
      marginBottom: 53,
      [theme.breakpoints.up("tablet")]: {
        marginBottom: 95,
      },
    },
    groupTitle: {
      fontSize: theme.typography.pxToRem(16.5),
      letterSpacing: 2.5,
      fontWeight: 700,
      padding: "30px 0 20px",
      textTransform: "uppercase",
      textAlign: "center",
      [theme.breakpoints.up("mobile")]: {
        padding: "30px 0 36px",
        fontSize: theme.typography.pxToRem(21),
        letterSpacing: 3,
        lineHeight: theme.typography.pxToRem(25),
      },
    },
    groupTitleHolidays: {
      color: theme.palette.categories.holidays,
    },
    groupTitleCelebrate: {
      color: theme.palette.categories.celebrate,
    },
    groupTitleGreetings: {
      color: theme.palette.categories.greetings,
    },
    link: {
      display: "block",
      textAlign: "center",
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(18),
      lineHeight: theme.typography.pxToRem(43),
      letterSpacing: ".64px",
      "&:hover": {
        textDecoration: "underline",
      },
      [theme.breakpoints.up("mobile")]: {
        fontSize: theme.typography.pxToRem(21),
        letterSpacing: ".75px",
        lineHeight: theme.typography.pxToRem(45),
      },
    },
  }),
  { name: "Categories" },
);
